import { render, staticRenderFns } from "./feedbackVerify.vue?vue&type=template&id=dfe2b884&scoped=true"
import script from "./feedbackVerify.vue?vue&type=script&lang=js"
export * from "./feedbackVerify.vue?vue&type=script&lang=js"
import style0 from "./feedbackVerify.vue?vue&type=style&index=0&id=dfe2b884&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe2b884",
  null
  
)

export default component.exports